import React from "react";

const DescriptionList = ({ description = "", className, isFreePlan }) => {
  let descriptionPoints = [];

if (Array.isArray(description)) {
  descriptionPoints = description;
} else if (typeof description === "string") {
  const formattedDescription = description
    ?.replace(/\\u003c/g, "<")
    ?.replace(/\\u003e/g, ">")
    ?.replace(/\\n/g, "\n");

  descriptionPoints = formattedDescription
    ?.split("\n")
    ?.map((line) =>
      line
        .replace(/^•\s*/, "")   //  remove bullet at start
        .trim()
    )
    ?.filter((line) => line !== "");
}

  return (
    <ul className={`list-unstyled ${className}`}>
      {descriptionPoints.map((point, index) => (
        <li key={index} className="d-flex align-items-start mb-3">
          {/*  Checkmark Icon styling matching image_65f95c.png */}
          <div
            className="d-flex align-items-center justify-content-center me-3"
            style={{
              background: isFreePlan
                ? "linear-gradient(135deg, #16a34a, #22c55e)"
                : "linear-gradient(135deg, #6366f1, #4338ca)",
              width: "18px",
              height: "18px",
              borderRadius: "50%",
              flexShrink: 0,
              marginTop: "4px", // Aligns icon with top of text
            }}
          >
            <i
              className="bi bi-check-lg text-white"
              style={{ fontSize: "11px" }}
            ></i>
          </div>

          {/*  Description Text */}
          <span
            className="text-dark-50"
            style={{ fontSize: "14px", lineHeight: "1.5" }}
          >
            {point}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default DescriptionList;
